<template>
  <div id="acuerdo-comercial">

    <!-- Loading copiado del app, para evitar condicion de carrera entre el redireccionamiento de la ruta y el montado de app -->
    <div v-if="loading_consorcios_pendientes" class="wrapper-loading">
      <v-progress-circular
        indeterminate
        size="100"
        width="10">
      </v-progress-circular>
    </div>

    <v-tabs class="ca-tabs" v-model="tabs_primer_nivel">

      <!-- Tabs -->
      <v-tab>{{ tituloNuevosConsorciosFormateado }}</v-tab>
      <v-tab>{{ tituloAcuerdosComercialesEnCurso }}</v-tab>
      <v-tab>Buscador</v-tab>

      <!-- Tooltip + Icono refresh (el tooltip solo se muestra cuando esta habilitado el icono del refresh) -->
      <ca-tooltip
        v-if="!ocultarBotonRefresh"
        posicion="arriba"
        solo-texto
        texto="Actualizar"
        customActivator
        :mostrarIcono="boton_refresh_habilitado"
        class="ml-auto mr-4"
      >
        <template slot="customActivator">

          <!-- Icono refresh -->
          <v-icon
            class="icono-refresh"
            :class="{
              'icono-refresh--animacion-rotacion': animacion_rotacion_habilitado,
              'icono-refresh--deshabilitado': !boton_refresh_habilitado
            }"
            :disabled="!boton_refresh_habilitado"
            @click="reiniciarTabs()">
            refresh
          </v-icon>

        </template>
      </ca-tooltip>
    </v-tabs>

    <v-tabs-items v-model="tabs_primer_nivel">

      <!-- 1er TAB - Nuevos consorcios [acuerdo_libre - no esta en uso actualmente] -->
      <v-tab-item>
        <nuevos-consorcios
          v-if="datos_consorcio_pendientes && datos_consorcio_pendientes.meta"
          ref="nuevos_consorcios"
          :consorcios_pendientes="this.datos_consorcio_pendientes.consorcios"
          @consorcios-seleccionados:actualizar="consorciosPendientesSeleccionados($event)"
          @consorcio-para-asignar-libre:seleccionado="abrirSidesheetAsignacionLibres($event)"
          @consorcios-seleccionados:archivar="show_modal_confirmar_archivar = true"
        ></nuevos-consorcios>

      </v-tab-item>

      <!-- 1er TAB - Acuerdo en curso -->
      <v-tab-item>
        <acuerdos-comerciales-en-curso ref="acuerdos_comerciales_en_curso" />
      </v-tab-item>

      <!-- 1er TAB - Buscador -->
      <v-tab-item>
        <buscador-acuerdos />
      </v-tab-item>

    </v-tabs-items>

    <!-- Sidesheet Creación [acuerdo_libre - no esta en uso actualmente]-->
    <template v-if="datos_consorcio_pendientes.api_links">
      <sidesheet-creacion-acuerdo
        ref="sidesheet_creacion_acuerdo"
        :show_sidesheet_creacion.sync="show_sidesheet_creacion"
        :camino="camino_actual"
        :tipo_acuerdo="tipo_acuerdo"
        @finalizada-exito:creacion="creacionFinalizadaExito($event)"
        @finalizada-error:creacion="operacionConError($event)"
        @acuerdo-libre:creacion="agregarAcuerdoLibre($event)"

        :modo_creacion_para_consorcios_pendientes="modo_creacion_para_consorcios_pendientes"
        :consorcios_pendientes="consorcios_seleccionados"
        :tipo_creacion_para_consorcios_pendientes=tipo_creacion_para_consorcios_pendientes
        :consorcios_pendientes_distinta_administracion="consorciosPendientesDiferentesAdministracion"
      />
    </template>

    <!-- Sidesheet Edición -->
    <sidesheet-edicion-acuerdo
      :show.sync="show_sidesheet_edicion"
      :acuerdo_comercial="acuerdo_comercial_seleccionado"
      @acuerdo-comercial-edicion:exito="exitoEdicionAcuerdo($event)"
      @acuerdo-comercial-edicion:error="errorEdicionAcuerdo($event)"
    >
    </sidesheet-edicion-acuerdo>

    <!-- Sidesheet Eliminación -->
    <sidesheet-eliminacion-acuerdo
      :show.sync="show_sidesheet_eliminacion"
      :acuerdo_comercial="acuerdo_comercial_seleccionado"
      @acuerdo-comercial:confirmar-eliminacion="show_modal_confirmar_eliminacion = true"
    >
    </sidesheet-eliminacion-acuerdo>

    <!-- Sidesheet Detalle e Historial -->
    <sidesheet-detalle-historial-acuerdo-comercial
      :abrir_tab_historial="abrir_tab_historial"
      :show_sidesheet_detalle_historial.sync="show_sidesheet_detalle_historial"
      :acuerdo_comercial="acuerdo_comercial_seleccionado"
      @abrir-sidesheet-edicion="accionABM($event, EDITAR)"
    >
    </sidesheet-detalle-historial-acuerdo-comercial>

    <!-- Modal confirmación de eliminación -->
    <ca-modal
      v-if="acuerdo_comercial_seleccionado"
      :show.sync="show_modal_confirmar_eliminacion"
      :titulo="tituloEliminar"
      tipo="warning"
      :width="acuerdo_comercial_seleccionado.tipo_propuesta === TIPO_ACUERDO_POR_DEFECTO ? '528px' : '457px' "
      botonAceptar
      botonAceptarLabel="Eliminar"
      @aceptar="eliminarAcuerdo()"
      botonCancelar
      contentClass="modal-eliminacion-acuerdo-comercial"
    >

      <!-- Chip en caso de eliminar acuerdo por defecto -->
      <ca-chip
        v-if="acuerdo_comercial_seleccionado.tipo_propuesta === TIPO_ACUERDO_POR_DEFECTO && acuerdo_comercial_seleccionado.administracion"
        disabled
        class="chip-custom-eliminacion-acuerdo mb-6"
      >
        <div slot="izquierda">
          <v-icon class="icon-info">info</v-icon>
        </div>

        <template>
          <span>Al eliminar el acuerdo de una administración, los próximos consorcios que se activen permanecerán en la sección <b>Nuevos consorcios</b> a la espera de que se les asigne un acuerdo.</span>
        </template>

      </ca-chip>

      <!-- Mensaje si es por defecto -->
      <div v-if="acuerdo_comercial_seleccionado.tipo_propuesta === TIPO_ACUERDO_POR_DEFECTO && acuerdo_comercial_seleccionado.administracion">
        <p>
          Se está por eliminar el acuerdo por defecto de la Administración {{ this.acuerdo_comercial_seleccionado.administracion.nombre }}.
        </p>
      </div>

      <!-- Mensaje si es para vinculada a consorcio -->
      <div v-if="acuerdo_comercial_seleccionado.tipo_propuesta === TIPO_ACUERDO_VINCULADO_A_CONSORCIO && acuerdo_comercial_seleccionado.consorcio">
        <p>Se está por eliminar el acuerdo del consorcio {{ this.acuerdo_comercial_seleccionado.consorcio.nombre }}.</p>
      </div>

      <!-- Mensaje si es libre [acuerdo_libre - no esta en uso actualmente] -->
      <div v-if="acuerdo_comercial_seleccionado.tipo_propuesta === TIPO_ACUERDO_LIBRE">
        <div v-if="!acuerdo_comercial_seleccionado.consorcio_propuesta_libre">
          <p>Se está por eliminar el acuerdo libre {{ this.acuerdo_comercial_seleccionado.codigo }}.</p>
        </div>
        <div v-else>
          <p>
            Se está por eliminar el acuerdo libre: <br>
            <b>{{ this.acuerdo_comercial_seleccionado.consorcio_propuesta_libre }}</b> ({{this.acuerdo_comercial_seleccionado.codigo }}).
          </p>
        </div>
      </div>

      <p>Esta acción no se puede deshacer.<br>¿Estás seguro de continuar?</p>
      <div slot="modal-content-details" v-if="acuerdo_comercial_seleccionado.tipo_propuesta === TIPO_ACUERDO_POR_DEFECTO">
        <p>Esta acción no afectará ningún acuerdo existente.</p>
      </div>
    </ca-modal>

    <!-- Modal confirmación de archivar consorcios seleccionados -->
    <ca-modal
      v-if="consorcios_seleccionados.length"
      :show.sync="show_modal_confirmar_archivar"
      titulo="Ocultar consorcios"
      botonAceptar
      botonAceptarLabel="Ocultar"
      @aceptar="archivarConsorciosPendientes()"
      botonCancelar
      contentClass="acuerdo-comercial-modal-archivar-consorcios"
    >
      <div v-if="consorcios_seleccionados.length > 1">
        Se van a ocultar {{ consorcios_seleccionados.length }} consorcios con acuerdo comercial pendiente.
      </div>
      <div v-else>
        Se va a ocultar {{ consorcios_seleccionados.length }} consorcio con acuerdo comercial pendiente.
      </div>
      <br>
      <div slot="modal-content-details">
        {{ consorcios_seleccionados.length > 1 ? 'Los consorcios permanecerán visibles' : 'El consorcio permanecerá visible'}} para la opción Crear Acuerdo.
      </div>
    </ca-modal>

    <!-- Boton para crear acuerdo comercial -->
    <ca-bottom-nav>
      <v-btn
        v-if="consorcios_seleccionados.length"
        class="boton-asignar-acuerdo"
        @click="comenzarCrearAcuerdoConsorciosPendientes()"
      >
        Asignar acuerdo
      </v-btn>
      <v-menu top rigth offset-y>
        <template v-slot:activator="{ on }">
          <v-btn :class="consorcios_seleccionados.length ? 'btn--flat boton--carga-agil boton-oscuro' : 'btn--flat boton--carga-agil'" v-on="on">
            Crear acuerdo
            <v-icon class="boton-icono--carga-agil">arrow_drop_up</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="inicioCrearAcuerdo(1)" tag="div">
            <v-list-item-title>Acuerdo para consorcios</v-list-item-title>
          </v-list-item>
          <v-list-item @click="inicioCrearAcuerdo(2)" tag="div">
            <v-list-item-title>Acuerdo por defecto para una administración</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </ca-bottom-nav>

    <!-- Modal de error generico -->
    <template v-if="error">
      <ca-modal
        :show.sync="show_modal_error"
        titulo="Error en la operación"
        tipo="error"
        botonAccion
        botonAccionLabel = 'Cerrar'
        @accion="error = null"
        contentClass="acuerdo-comercial-modal-error"
      >
        <div class="mensaje">
          <p>La operación no pudo completarse a causa de un error inesperado.</p>
          <p>Ponete en contacto con el equipo de tecnología para informar la situación.</p>
        </div>
        <p class="mensaje-error-modal">Mensaje de error: {{ error }}</p>
      </ca-modal>
    </template>

    <!-- Modal para consorcios pendientes y admins con acuerdo default -->
    <ca-modal
      :show.sync="show_modal_acuerdo_default"
      titulo="Acuerdo por defecto"
      botonCancelar
      botonAceptar
      botonAceptarLabel = 'Usar acuerdo por defecto'
      @aceptar="inicioCreacionAcuerdoParaConsorciosPendientes(USAR_ACUERDO_POR_DEFECTO_ADMIN)"
      contentClass="acuerdo-comercial-modal-acuerdo-default"
    >
      <div class="mensaje" v-if="consorcios_seleccionados.length && consorcios_seleccionados[0].administracion">
        <p>La administración <b>{{ consorcios_seleccionados[0].administracion.nombre }}</b> ya cuenta con un acuerdo por defecto para sus consorcios.</p>
        <p>¿Querés usar el acuerdo por defecto o crear uno nuevo?</p>
      </div>

      <!-- Botón custom para crear un acuerdo y no usar la por defecto -->
      <div slot="modal-botones-accion">
        <v-btn
          outlined
          class="boton-acuerdo-default-crear-nueva"
          @click="inicioCreacionAcuerdoParaConsorciosPendientes(CREAR_DESDE_CERO)"
        >
          Crear nuevo
        </v-btn>
      </div>
    </ca-modal>

    <!-- Modal para extender/finalizar el tiempo de trial que tiene un AC -->
    <modal-modificar-tiempo-trial-acuerdo-comercial
      v-if="acuerdo_comercial_seleccionado"
      :show.sync="show_modal_extender_finalizar_trial"
      :acuerdo_comercial="acuerdo_comercial_seleccionado"
      :modo_extender_tiempo_aceptacion="modo_extender_tiempo_aceptacion_modal"
      @exito-acuerdo:accion-trial="exitoAccionTrial($event)"
    />
  </div>
</template>

<script>
import NuevosConsorcios from './components/NuevosConsorcios.vue';
import AcuerdosComercialesEnCurso from './components/AcuerdosComercialesEnCurso.vue';
import BuscadorAcuerdos from './components/BuscadorAcuerdos.vue';
import SidesheetCreacionAcuerdo from './components/SidesheetCreacionAcuerdo.vue';
import SidesheetEliminacionAcuerdo from './components/SidesheetEliminacionAcuerdo.vue';
import SidesheetEdicionAcuerdo from './components/SidesheetEdicionAcuerdo.vue';
import { LAYOUT_MUTATION_MODAL, LAYOUT_MUTATION_MODAL_ERROR, LAYOUT_MUTATION_MOSTRAR_LOADING, LAYOUT_MUTATION_OCULTAR_LOADING, LAYOUT_MUTATION_SNACKBAR_EXITO } from '@/store/layout/layout.types';
import { APIAcuerdoComercial } from './api/acuerdo-comercial.api';
import * as acuerdo_comercial_constantes from './acuerdo-comercial.consts';
import { Consorcio } from '../../models/Consorcio';
import { CACHE_ADMIN_MUTATION_ELIMINAR_ADMIN } from '@/store/administraciones/administraciones.types';

import { FormatFecha } from '@/components/vue_filters';
import { CACHE_ACUERDOS_LIBRES_MUTATION_AGREGAR, CACHE_ACUERDOS_LIBRES_MUTATION_ELIMINAR, CACHE_ACUERDOS_LIBRES_MUTATION_MODIFICAR } from '@/store/acuerdos-libres/acuerdos-libres.types';
import { EventBus } from '@/main';
import SidesheetDetalleHistorialAcuerdoComercial from './components/SidesheetDetalleHistorialAcuerdoComercial.vue';
import ModalModificarTiempoTrialAcuerdoComercial from './components/ModalModificarTiempoTrialAcuerdoComercial.vue';
import { METADATA_MUTATION_IVA, METADATA_MUTATION_MINIMO_UFS_PLATAFORMA, METADATA_MUTATION_PRECIO_UFS, METADATA_MUTATION_USUARIOS_SALES } from '@/store/metadata/metadata.types';
import { ENDPOINT_GETTER, ENDPOINT_MUTATION_AGREGAR } from '@/store/endpoints/endpoints.types';

export default {
  name: 'AcuerdoComercial',
  components: {
    NuevosConsorcios,
    AcuerdosComercialesEnCurso,
    BuscadorAcuerdos,
    SidesheetCreacionAcuerdo,
    SidesheetEliminacionAcuerdo,
    SidesheetEdicionAcuerdo,
    SidesheetDetalleHistorialAcuerdoComercial,
    ModalModificarTiempoTrialAcuerdoComercial
  },
  data: () => ({
    tabs_primer_nivel: 0,

    // Camino son la series de paso que se deben seguir para crear un acuerdo
    // y el paso_actual es necesario para saber en que paso se encuentra el usuario en la creación
    camino_actual: {'camino': [], 'paso_actual': 0},

    datos_consorcio_pendientes: {}, // Listados: consorcios nuevos/pendientes

    consorcios_seleccionados: [], // Listados de nuevos consorcios (pendientes) seleccionados
    consorcio_para_asignar_libre: null, // Consorcio seleccionado para asignarle un acuerdo libre [acuerdo_libre - no esta en uso actualmente]

    // Manejo del ABM
    acuerdo_comercial_seleccionado: null,
    accion: '',

    tipo_acuerdo: '', // Tipos de acuerdos (libre, vinculada a un consorcio, por_defecto)

    // Flag para mostrar los sidesheets
    show_sidesheet_creacion: false,
    show_sidesheet_edicion: false,
    show_sidesheet_eliminacion: false,
    show_sidesheet_detalle_historial: false,
    show_sidesheet_asignacion_libres: false, // [acuerdo_libre - no esta en uso actualmente]

    // Flag para mostrar los modals
    show_modal_error: false,
    show_modal_confirmar_eliminacion: false,
    show_modal_acuerdo_default: false,
    show_modal_confirmar_archivar: false,
    show_modal_extender_finalizar_trial: false,

    abrir_tab_historial: false, // Flag para abrir el sidesheet de detalles en el tab de historial

    error: null,

    modo_creacion_para_consorcios_pendientes: false, // Flag para activar el modo creación para consorcios pendientes en el sidesheet de creación
    tipo_creacion_para_consorcios_pendientes: 0, // Para guardar la forma en la que crear el acuerdo (Desde cero o usando la por defecto)

    // Constantes
    ELIMINAR: acuerdo_comercial_constantes.ELIMINAR,
    VISUALIZAR: acuerdo_comercial_constantes.VISUALIZAR,
    EDITAR: acuerdo_comercial_constantes.EDITAR,
    EXTENDER_TIEMPO: acuerdo_comercial_constantes.EXTENDER_TIEMPO,
    FINALIZAR_PERIODO_ACEPTACION: acuerdo_comercial_constantes.FINALIZAR_PERIODO_ACEPTACION,
    TIPO_ACUERDO_LIBRE: acuerdo_comercial_constantes.TipoAcuerdo.LIBRE, // [acuerdo_libre - no esta en uso actualmente]
    TIPO_ACUERDO_POR_DEFECTO: acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION,
    TIPO_ACUERDO_VINCULADO_A_CONSORCIO: acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO,
    CREAR_DESDE_CERO: acuerdo_comercial_constantes.TipoCreacionPendientes.CREAR_DESDE_CERO,
    USAR_ACUERDO_POR_DEFECTO_ADMIN: acuerdo_comercial_constantes.TipoCreacionPendientes.USAR_ACUERDO_POR_DEFECTO_ADMIN,

    // Flag para mostrar el loading custom
    loading_consorcios_pendientes: false,

    // Controles para refresh
    animacion_rotacion_habilitado: false, // Control para activar rotación del icono
    boton_refresh_habilitado: true,

    modo_extender_tiempo_aceptacion_modal: false, // Flag para indicar si el modal de extender tiempo de aceptación esta en modo extender o finalizar periodo de aceptación

    acciones_obtener_acuerdo_comercial_reducido: [acuerdo_comercial_constantes.EXTENDER_TIEMPO, acuerdo_comercial_constantes.FINALIZAR_PERIODO_ACEPTACION] // Acciones que pueden ser invocadas con el acuerdo comercial reducido
  }),
  created() {

    /**
     * Hook para abrir el sidesheet de detalles e historial de un acuerdo comercial
     */
    EventBus.$on('sidesheet-detalles:abrir', (acuerdo_comercial) => {
      this.accionABM(acuerdo_comercial, this.VISUALIZAR);
      this.abrir_tab_historial = false; // Seteamos en falso el flag para que se abra el sidesheet de detalles a historial con el tab de detalles activo
    });

    /**
     * Hook para abrir el sidesheet de detalles e historial en el tab de historial
     */
    EventBus.$on('sidesheet-detalles:abrir-historial', (acuerdo_comercial) => {
      this.accionABM(acuerdo_comercial, this.VISUALIZAR);
      this.abrir_tab_historial = true; // Seteamos en verdadero el flag para que se abra el sidesheet de detalles e historial con el tab de historial activo
    });

    /**
     * Hook para abrir el sidesheet de eliminación de un acuerdo comercial
     */
    EventBus.$on('sidesheet-eliminacion:abrir', (acuerdo_comercial) => {
      this.accionABM(acuerdo_comercial, this.ELIMINAR);
    });

    /**
     * Hook para abrir el sidesheet de edición de un acuerdo comercial
     */
    EventBus.$on('sidesheet-edicion:abrir', (acuerdo_comercial) => {
      this.accionABM(acuerdo_comercial, this.EDITAR);
    });

    EventBus.$on('modal-extender:abrir', (acuerdo_comercial) => {
      this.accionABM(acuerdo_comercial, this.EXTENDER_TIEMPO);
    });

    EventBus.$on('modal-finalizar-periodo:abrir', (acuerdo_comercial) => {
      this.accionABM(acuerdo_comercial, this.FINALIZAR_PERIODO_ACEPTACION);
    });
  },
  /**
   * Elimino los listeners de los eventos para evitar comportamientos inesperados
   */
  beforeDestroy() {
    EventBus.$off('sidesheet-detalles:abrir');
    EventBus.$off('sidesheet-eliminacion:abrir');
    EventBus.$off('sidesheet-edicion:abrir');
    EventBus.$off('modal-extender:abrir');
    EventBus.$off('modal-finalizar-periodo:abrir');
    EventBus.$off('sidesheet-edicion:abrir');
  },
  computed:{

    /**
     * Computed que indica cuando se debe ocultar el botón de refresh dependiendo del tab que se encuentre activo
     */
    ocultarBotonRefresh() {
      return this.tabs_primer_nivel === acuerdo_comercial_constantes.TAB_BUSCADOR;
    },

    /**
     * Computed para calcular el titulo del tab Nuevos Consorcios, dependiendo si esta definida la cantidad de nuevos consorcios
     */
    tituloNuevosConsorciosFormateado(){
      let titulo_tab_nuevos_consorcios = 'Nuevos consorcios';

      if (this.datos_consorcio_pendientes?.meta?.nuevos_consorcios) {
        titulo_tab_nuevos_consorcios += ' (' + this.datos_consorcio_pendientes.meta.nuevos_consorcios + ')';
      }

      return titulo_tab_nuevos_consorcios;
    },

    /**
     * Computed para calcular el titulo del tab Acuerdos en cursos, dependiendo si esta definida la cantidad de elementos
     */
    tituloAcuerdosComercialesEnCurso() {
      let titulo_tab_acuerdos_en_curso = 'Acuerdos en curso';

      if(this.datos_consorcio_pendientes?.meta?.cantidad_propuestas_pendientes) {
        titulo_tab_acuerdos_en_curso += ' (' + this.datos_consorcio_pendientes.meta.cantidad_propuestas_pendientes + ')';
      }

      return titulo_tab_acuerdos_en_curso;
    },

    /**
     * Chequea si los consorcios seleccionados permanencen a una unica administración o no.
     * - False en caso que sean consorcios de una unica administración,
     * - True en caso contrario.
     */
    consorciosPendientesDiferentesAdministracion(){
      let distinta_administracion = false;

      if (this.consorcios_seleccionados.length) {
        let primer_consorcio = this.consorcios_seleccionados[0]; // me quedo con el primero
        let index = this.consorcios_seleccionados.findIndex((ac) => primer_consorcio.administracion.id !== ac.administracion.id);

        if (index !== -1){ // Si encontro significa que SI hay un admin que tenga distinto ID.
          distinta_administracion = true;
        }
      }
      return distinta_administracion;
    },

    /**
     * Computed para calcular el titulo del modal para confirmar la eliminación
     */
    tituloEliminar(){
      if (this.acuerdo_comercial_seleccionado){
        switch (this.acuerdo_comercial_seleccionado.tipo_propuesta) {
        case this.TIPO_ACUERDO_LIBRE: // [acuerdo_libre - no esta en uso actualmente]
          return 'ELIMINAR ACUERDO LIBRE';
        case this.TIPO_ACUERDO_POR_DEFECTO:
          return 'ELIMINAR ACUERDO POR DEFECTO';
        default:
          return 'ELIMINAR ACUERDO';
        }
      }
      else{
        return '';
      }
    }
  },
  mounted() {
    this.loading_consorcios_pendientes = true;
    APIAcuerdoComercial.getConsorciosPendientes({'archivados': false})
      .then((resp) => {

        // LOGICA CONSORCIOS PENDIENTES
        this.datos_consorcio_pendientes = resp;

        // Actualizó los valores de la metadata en el store con la respuesta de la API
        this.actualizarStoreMetadata(resp);

        // Actualizó los endpoints en el store con la respuesta de la API
        this.actualizarStoreEndpoints(resp);

        // Marco como deseleccionados a todos los consorcios 
        // Necesario para poder detectar luego en computed de (nuevos consorcios) cuando selecciona todos los consorcios.
        // Es decir, si el atributo del objeto no esta definido antes de inicializar la computed, no lo detecta. 
        this.datos_consorcio_pendientes.consorcios.forEach((consorcio) => consorcio.seleccionado = false);
      })
      .catch((err) => {
        console.log(err);
        this.error = err.detail;
        this.show_modal_error = true;
      })
      .finally(() => {
        this.loading_consorcios_pendientes = false;
      });
  },
  methods: {

    /**
     * Metodo encargado de accionar el refresh del tab de acuerdos en curso como del tab de nuevos consorcios
     * 
     *  - Habilita la animación de rotación del icono (la desactivamos nuevamente luego de 0.75 seg)
     *  - Deshabilita el botón de refresh para evitar que se ejecute constantemente (habilitamos el botón pasado 1 min)
     *  - Reiniciamos ambos tabs (acuerdos en curso y nuevos consorcios)
     *    - El tab de acuerdos en cursos se reiniciara si se aprieta el botón de refresh y esta montado el tab.
     *    - Además se llama al metodo para actualizar los headers de la tabla (con la nueva información que vino con el refresh).
     */
    async reiniciarTabs(){
      this.animacion_rotacion_habilitado = true;
      this.boton_refresh_habilitado = false;

      // Detenemos la animación después de 0.75 segundos (duración de la animación)
      setTimeout(() => {
        this.animacion_rotacion_habilitado = false;
      }, 750);

      // Luego de 1 minuto reactivamos el botón de refresh
      setTimeout(() => {
        this.boton_refresh_habilitado = true;
      }, 60000);

      this.getConsorciosPendientes(false, false, true); // Reinicio el tab de nuevos consorcios

      if(this.$refs.acuerdos_comerciales_en_curso) {
        await this.$refs.acuerdos_comerciales_en_curso.recuperarAcuerdosComercialesEnCurso(); // Reinicio el tab de acuerdos en curso

        this.$refs.acuerdos_comerciales_en_curso.actualizarHeadersTabla();
      }
    },

    /**
     * Metodo para seter los valores de la metadata en el store con los valores de la respuesta de la API
     */
    actualizarStoreMetadata(respuesta_api_consorcios_pendientes) {

      // Usuario sales
      this.$store.commit(METADATA_MUTATION_USUARIOS_SALES, respuesta_api_consorcios_pendientes.meta.usuarios_sales);

      // IVA (formateado de porcentaje a factor multiplicador)
      this.$store.commit(METADATA_MUTATION_IVA, 1 + (respuesta_api_consorcios_pendientes.meta.iva / 100));

      // Precio de las UFs
      this.$store.commit(METADATA_MUTATION_PRECIO_UFS, {
        precio_barrio: respuesta_api_consorcios_pendientes.meta.montos.barrio,
        precio_edificio: respuesta_api_consorcios_pendientes.meta.montos.edificio
      });

      // Minimo ufs permitidos en la plataforma
      this.$store.commit(METADATA_MUTATION_MINIMO_UFS_PLATAFORMA, respuesta_api_consorcios_pendientes.meta.minimo_ufs_facturables);
    },

    /**
     * Metodo para setear los valores del store de endpoints con los valores de la respuesta de la API
     * 
     * Enviamos un arreglo con dos elementos:
     *  - El nombre del endpoint
     *  - El valor del endpoint en la respuesta de la API
     */
    actualizarStoreEndpoints(respuesta_api_consorcios_pendientes) {
      this.$store.commit(ENDPOINT_MUTATION_AGREGAR, ['propuestas_pendientes', respuesta_api_consorcios_pendientes.getApiLink('propuestas_pendientes')]);
      this.$store.commit(ENDPOINT_MUTATION_AGREGAR, ['propuestas', respuesta_api_consorcios_pendientes.getApiLink('propuestas')]);
      this.$store.commit(ENDPOINT_MUTATION_AGREGAR, ['crear_propuesta', respuesta_api_consorcios_pendientes.getApiLink('crear_propuesta')]);
      this.$store.commit(ENDPOINT_MUTATION_AGREGAR, ['plantillas', respuesta_api_consorcios_pendientes.getApiLink('plantillas')]);
      this.$store.commit(ENDPOINT_MUTATION_AGREGAR, ['administraciones', respuesta_api_consorcios_pendientes.getApiLink('administraciones')]);
      this.$store.commit(ENDPOINT_MUTATION_AGREGAR, ['editar_archivar', respuesta_api_consorcios_pendientes.getApiLink('editar_archivar')]);
    },

    /**
     * Metodo que recupera todos los consorcios pendientes, encargado de usar el helper para hacer el llamado a la api
     * 
     * @param boolean recuperar_archivados, flag para saber si se debe traer o no los archivados, por defecto no se traen
     * @param boolean mostrar_loading, flag para evitar que el método controle el loading, ya que en algunos casos el que llama lo controla
     * @param boolean loading_refresh_tab, flag para saber si se debe mostrar el loading en la tabla de nuevos consorcios (cuando se hace el refresh)
     */
    async getConsorciosPendientes(recuperar_archivados = false, mostrar_loading = true, loading_refresh_tab = false) {
      if (mostrar_loading) {
        this.$store.commit(LAYOUT_MUTATION_MOSTRAR_LOADING);
      }

      // En caso de refresh, actualizamos el valor del loading de la tabla de consorcios pendientes
      if (this.$refs.nuevos_consorcios && loading_refresh_tab) {
        this.$refs.nuevos_consorcios.loading_tabla = true;
      }

      await APIAcuerdoComercial.getConsorciosPendientes({'archivados': recuperar_archivados})
        .then((resp) => {
          this.datos_consorcio_pendientes = resp;

          // Actualizamos la lista de usuarios de sales en el store con los nuevos valores
          this.$store.commit(METADATA_MUTATION_USUARIOS_SALES, resp.meta.usuarios_sales);

          // Marco como deseleccionados a todos los consorcios 
          // Necesario para poder detectar luego en computed de (nuevos consorcios) cuando selecciona todos los consorcios.
          // Es decir, si el atributo del objeto no esta definido antes de inicializar la computed, no lo detecta. 
          this.datos_consorcio_pendientes.consorcios.forEach((consorcio) => consorcio.seleccionado = false);
        })
        .catch((err) => {
          console.log(err);
          this.error = err.detail;
          this.show_modal_error = true;
        })
        .finally(() => {
          if (mostrar_loading) {
            this.$store.commit(LAYOUT_MUTATION_OCULTAR_LOADING);
          }

          // En caso de refresh, actualizamos el valor del loading de la tabla de consorcios pendientes
          if (this.$refs.nuevos_consorcios && loading_refresh_tab) {
            this.$refs.nuevos_consorcios.loading_tabla = false;
          }
        });
    },

    /**
     *  Metodo hook para responder al evento de NuevosConsorcios
     *
     * @param {Array} consorcios_seleccionados
     */
    consorciosPendientesSeleccionados(consorcios_seleccionados) {
      this.consorcios_seleccionados = consorcios_seleccionados;
    },

    /**
     * Dependiendo de que tipo de acuerdo se va a setear el camino a seguir y se lo ubica al inicio
     * Mostrando el sidesheet de creación con este nuevo camino y tipo de acuerdo
     */
    inicioCrearAcuerdo(tipo){
      switch (tipo) {
      case 0: // Libre [acuerdo_libre - no esta en uso actualmente]
        this.tipo_acuerdo = acuerdo_comercial_constantes.TipoAcuerdo.LIBRE;
        this.camino_actual = {
          camino: acuerdo_comercial_constantes.CAMINO_ACUERDO_LIBRE,
          paso_actual: 0
        };
        break;
      case 1: // Vinculada a consorcio / masiva
        this.tipo_acuerdo = acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO;
        this.camino_actual = {
          camino: acuerdo_comercial_constantes.CAMINO_ACUERDO_VINCULADO_A_CONSORCIOS,
          paso_actual: 0
        };
        break;
      case 2: // Por defecto a la administración
        this.tipo_acuerdo = acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION;
        this.camino_actual = {
          camino: acuerdo_comercial_constantes.CAMINO_ACUERDO_POR_DEFECTO,
          paso_actual: 0
        };
        break;
      default:
        break;
      }
      this.modo_creacion_para_consorcios_pendientes = false;
      this.show_sidesheet_creacion = true;
    },

    /**
     * Agrega el acuerdo libre a la cache e incrementa el contador de acuerdos libres
     * Evitando asi hacer el GET nuevamente
     * @param {AcuerdoComercial} acuerdo
     */
    agregarAcuerdoLibre(acuerdo){
      this.$store.commit(CACHE_ACUERDOS_LIBRES_MUTATION_AGREGAR, acuerdo);
      this.datos_consorcio_pendientes.meta.propuestas_libres++;
    },

    /**
     * Metodo para setear el error y mostrar el modal para notificarlo
     *
     * @param {string} error
     */
    operacionConError(error){
      this.error = error;
      this.show_sidesheet_creacion = false;
      this.show_modal_error = true;
    },

    /**
     * Metodo para mostrar feedback de creacion finalizada con éxito y reiniciar
     */
    creacionFinalizadaExito(msg){
      this.show_sidesheet_creacion = false;

      this.$store.commit(LAYOUT_MUTATION_SNACKBAR_EXITO, msg);

      // Reinicios 
      this.getConsorciosPendientes(); // Traigo los consorcios pendientes a modo reinicio

      // Si fue con exito la creación para consorcios nuevos (pendientes) debo reiniciar la lista
      if (this.modo_creacion_para_consorcios_pendientes){
        this.actualizarListaNuevosConsorcios();
      }
    },

    /**
     * Metodo para actualizar la lista que es mostrada en el componente nuevos consorcios
     * Para eso busco en los consorcios que son pasados a este componente (los que selecciono el usuario)
     * Y por cada uno de ellos lo elimino de los pendientes
     * Al existir un watch de la propiedad en nuevos consorcios, se actualiza automaticamente
     */
    actualizarListaNuevosConsorcios(){
      this.consorcios_seleccionados.forEach((consorcio) => {
        let index = -1;

        index = this.datos_consorcio_pendientes.consorcios.findIndex((c) => c.id === consorcio.id);

        if (index !== -1){
          this.datos_consorcio_pendientes.consorcios.splice(index,1);
        }
      });
    },

    /**
     * Metodo para recuperar el acuerdo comercial completo o reducido, de acuerdo al parametro recibido.
     */
    async getAcuerdoComercial(acuerdo, obtener_reducido = false) {
      const url = obtener_reducido ? acuerdo.getApiLinkHref('obtener_reducida') : acuerdo.getApiLinkHref('obtener_completa');

      if (url){
        this.$store.commit(LAYOUT_MUTATION_MOSTRAR_LOADING);
        await APIAcuerdoComercial.getAcuerdoComercial(url)
          .then((acuerdo_comercial) => {
            this.acuerdo_comercial_seleccionado = acuerdo_comercial;
          })
          .catch((err) => {
            console.log(err);
            this.$store.commit(LAYOUT_MUTATION_MODAL_ERROR, {
              titulo: err.title,
              texto: err.detail
            });
          })
          .finally(() => {
            this.$store.commit(LAYOUT_MUTATION_OCULTAR_LOADING);
          });
      } else { // Estaba cacheada, reducido
        this.acuerdo_comercial_seleccionado = acuerdo;
      }
    },

    /**
     * Hook en caso que seleccione una fila, para realizar la acción segun flag
     */
    async accionABM(acuerdo, accion){

      this.accion = accion;
      this.acuerdo_comercial_seleccionado = null;

      /**
       * Caso borde: consorcio facturando
       * 
       * En caso de querer eliminar un AC, cuyo consorcio vinculado este facturando
       * Se detecta antes para no realizar la busqueda del acuerdo completo ya que
       * En este caso no se permite la eliminación del AC. (Corta el flujo)
       */
      if (this.ELIMINAR === accion){
        if (acuerdo.tipo_propuesta === this.TIPO_ACUERDO_VINCULADO_A_CONSORCIO && acuerdo.consorcio && acuerdo.consorcio.facturando){
          let msg = {
            titulo: 'Eliminar acuerdo',
            texto: 'El consorcio ' + acuerdo.consorcio.nombre + ' ya entró en el ciclo de facturación.<br><b>No es posible eliminar este acuerdo.<b/>'
          };
          this.$store.commit(LAYOUT_MUTATION_MODAL, msg);
          return;
        }
      }

      /**
       * Se obtiene el AC 
       *  - Reducido: en cualquier acción de la lista que no requiera toda la información del AC
       *  - Completo: en el resto de acciones
       * 
       * El AC recuperado es cargado en acuerdo_comercial_seleccionado
       */
      const obtener_reducido = this.acciones_obtener_acuerdo_comercial_reducido.includes(accion);
      await this.getAcuerdoComercial(acuerdo, obtener_reducido);

      switch (this.accion) {

      // En caso de querer visualizar el sidesheet de detalles e historial
      case this.VISUALIZAR:
        this.show_sidesheet_detalle_historial = true;
        break;
      case this.EDITAR:

        // Necesario porque en la vista creación esta pensada para creaciones masivas también
        this.acuerdo_comercial_seleccionado.consorcios_seleccionados = [];
        if (this.acuerdo_comercial_seleccionado.tipo_propuesta === this.TIPO_ACUERDO_VINCULADO_A_CONSORCIO){

          // Creo el consorcio
          let consorcio = new Consorcio();
          consorcio.setDataFromStorage(this.acuerdo_comercial_seleccionado.consorcio);

          this.acuerdo_comercial_seleccionado.consorcios_seleccionados.push(consorcio);
        }

        // En caso que sea vinculada a consorcio y tenga fecha seteada, paso ese atributo al AC para que se cargue / modifique en la vista
        if (this.acuerdo_comercial_seleccionado.propuesta_consorcio){
          this.acuerdo_comercial_seleccionado.periodo_inicio_facturacion = this.acuerdo_comercial_seleccionado.propuesta_consorcio.periodo_inicio_facturacion;

          // La formateo ya que en los inputs (para detectar cambios) se utiliza sin los dias
          this.acuerdo_comercial_seleccionado.periodo_inicio_facturacion = FormatFecha(this.acuerdo_comercial_seleccionado.periodo_inicio_facturacion, 'yyyy-MM');
        }

        this.show_sidesheet_edicion= true;
        break;
      case this.ELIMINAR:
        this.show_sidesheet_eliminacion= true;
        break;
      case this.EXTENDER_TIEMPO:
      case this.FINALIZAR_PERIODO_ACEPTACION:
        this.show_modal_extender_finalizar_trial = true;
        this.modo_extender_tiempo_aceptacion_modal = (this.accion === this.EXTENDER_TIEMPO);
        break;
      default:
        break;
      }
    },

    /**
     * Metodo para ejecutar efectivamente la eliminación de un AC
     * - Implica llamado al endpoint
     * - Reinicios en componentes por cambios en la eliminación del acuerdo
     */
    async eliminarAcuerdo(){
      this.$store.commit(LAYOUT_MUTATION_MOSTRAR_LOADING);
      try {
        await APIAcuerdoComercial.eliminarAcuerdoComercial(this.acuerdo_comercial_seleccionado.api_links['eliminar'].href)
          .then(async () => {

            // Actualizo la listas de acuerdo sea libre o vinculada a consorcio/administración

            // Libre [acuerdo_libre - no esta en uso actualmente]
            if (this.acuerdo_comercial_seleccionado.tipo_propuesta === this.TIPO_ACUERDO_LIBRE){
              this.$store.commit(CACHE_ACUERDOS_LIBRES_MUTATION_ELIMINAR, this.acuerdo_comercial_seleccionado);
              this.datos_consorcio_pendientes.meta.propuestas_libres--;
            }

            // Vinculada
            if (this.acuerdo_comercial_seleccionado.tipo_propuesta === this.TIPO_ACUERDO_POR_DEFECTO || this.acuerdo_comercial_seleccionado.tipo_propuesta === this.TIPO_ACUERDO_VINCULADO_A_CONSORCIO){

              // Recupero los consorcio pendientes nuevamente a modo reinicio, porque puede haber eliminado un acuerdo que estaba en nuevos consorcios antes.
              // Es necesario el reinicio completo ya que los endpoints eliminar y pendientes no traen la misma data sobre el consorcio
              await this.getConsorciosPendientes(false, false); // No recupero los archivos, y oculto el loading ya que lo controlo acá

              // Elimino la administración de la cache, para forzar a buscar nuevamente
              this.$store.commit(CACHE_ADMIN_MUTATION_ELIMINAR_ADMIN, this.acuerdo_comercial_seleccionado.administracion);

              // Actualizo la prop "tiene_acuerdo_comercial" de la administración de la lista no cacheada que tiene el sidesheet de creacion acuerdo
              if (this.acuerdo_comercial_seleccionado.tipo_propuesta === acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION){
                if (this.$refs.sidesheet_creacion_acuerdo){
                  this.$refs.sidesheet_creacion_acuerdo.actualizarAdministracion(this.acuerdo_comercial_seleccionado.administracion);
                }
              }
            }

            // Emito evento para que se actualicen los valores de los acuerdos comerciales en los tabs
            EventBus.$emit('acuerdo-comercial:eliminar', this.acuerdo_comercial_seleccionado);

            this.$store.commit(LAYOUT_MUTATION_SNACKBAR_EXITO, 'El acuerdo se eliminó correctamente');
          });
      } catch(err) {
        this.$store.commit(LAYOUT_MUTATION_MODAL_ERROR, {
          titulo: err.title,
          texto: err.detail
        });
      } finally {
        this.$store.commit(LAYOUT_MUTATION_OCULTAR_LOADING);
      }
    },

    /**
     * Mensaje de exito en caso de que sea exitosa la edición del acuerdo
     * Sumado a los reinicios/actualización en los componentes por la edición del acuerdo
     *
     * @param {AcuerdoComercial} acuerdo_editado
     */
    exitoEdicionAcuerdo(acuerdo_editado){

      // Si es un acuerdo libre la que se edito, actualizo la cache con el acuerdo comercial modificado [acuerdo_libre - no esta en uso actualmente]
      if (acuerdo_editado.tipo_propuesta === this.TIPO_ACUERDO_LIBRE){
        this.$store.commit(CACHE_ACUERDOS_LIBRES_MUTATION_MODIFICAR, acuerdo_editado);
      }

      // Si es un acuerdo vinculado, actualizo la lista invocando metodo especifico en el componente
      if (acuerdo_editado.tipo_propuesta === this.TIPO_ACUERDO_POR_DEFECTO || acuerdo_editado.tipo_propuesta === this.TIPO_ACUERDO_VINCULADO_A_CONSORCIO){

        // Solo si es por defecto
        if(acuerdo_editado.tipo_propuesta === this.TIPO_ACUERDO_POR_DEFECTO){

          // Elimino la admin si es que esta cacheada, para obligar a recuperar ante modificación
          this.$store.commit(CACHE_ADMIN_MUTATION_ELIMINAR_ADMIN, acuerdo_editado.administracion);

          // Reinicio nuevos consorcios
          this.getConsorciosPendientes();
        }

      }

      // Emito evento para que se actualicen los valores de los acuerdos comerciales en los tabs
      EventBus.$emit('acuerdo-comercial:editado', acuerdo_editado);

      this.$store.commit(LAYOUT_MUTATION_SNACKBAR_EXITO, 'El acuerdo se actualizó correctamente');
    },

    /**
     * Metodo encargado de la logica en caso de fallo en la edición
     */
    errorEdicionAcuerdo(detalles_error){
      this.$store.commit(LAYOUT_MUTATION_MODAL_ERROR, {texto: detalles_error.detail, titulo: detalles_error.title});
    },

    /**
     * Metodo para destiguir caso borde de que la administración tenga acuerdo por defecto
     */
    comenzarCrearAcuerdoConsorciosPendientes(){

      if(this.consorciosPendientesDiferentesAdministracion){
        this.inicioCreacionAcuerdoParaConsorciosPendientes(this.CREAR_DESDE_CERO);
      }
      else{
        let primer_consorcio = this.consorcios_seleccionados[0];

        // Caso borde: que tenga un acuerdo por default la administración del consorcio
        // Elige modo de creación desde modal entonces sino es desde cero
        primer_consorcio.propuesta_default ? this.show_modal_acuerdo_default = true : this.inicioCreacionAcuerdoParaConsorciosPendientes(this.CREAR_DESDE_CERO);
      }

    },

    /**
     * Inicio de creación acuerdo para los consorcios pendientes
     * Se tiene 2 formas: 
     *   - Crear el acuerdo desde cero
     *   - Crear el acuerdo pero tomando como plantilla el acuerdo por defecto de la administración
     */
    inicioCreacionAcuerdoParaConsorciosPendientes(modo_creacion){
      this.show_modal_acuerdo_default = false;
      this.tipo_acuerdo = acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO;
      this.tipo_creacion_para_consorcios_pendientes = modo_creacion;

      if (this.tipo_creacion_para_consorcios_pendientes === this.CREAR_DESDE_CERO){
        this.camino_actual = {
          camino: acuerdo_comercial_constantes.CAMINO_ACUERDO_VINCULADO_A_CONSORCIOS_PENDIENTES,
          paso_actual: 0
        };
      }
      else{ // Modo desde el acuerdo por defecto
        this.camino_actual = {
          camino: acuerdo_comercial_constantes.CAMINO_ACUERDO_VINCULADA_A_CONSORCIOS_PENDIENTES_USANDO_ACUERDO_ADMINISTRACION,
          paso_actual: 0
        };
      }

      this.modo_creacion_para_consorcios_pendientes = true;
      this.show_sidesheet_creacion = true;
    },

    /**
     * Metodo invocado gracias al evento de nuevos consorcios, para eliminar un consorcio pendiente del listado
     */
    eliminarConsorcioPendiente(consorcio_eliminado){
      let index = this.datos_consorcio_pendientes.consorcios.findIndex((consorcio) => consorcio.id === consorcio_eliminado.id);
      index !== -1 ? this.datos_consorcio_pendientes.consorcios.splice(index,1) : null;
    },

    /**
     * Metodo para accionar ante el exito de asignar un acuerdo libre a un consorcio pendiente
     */
    resultadoAsignacionAcuerdoLibre(acuerdo_asignado){
      this.eliminarConsorcioPendiente(this.consorcio_para_asignar_libre);// Elimino el consorcio asignado del listado de pendientes (actualiza la lista)
      this.eliminarAcuerdoAsignado(acuerdo_asignado);// Actualizo la lista de acuerdos libres y reduzco contadores
      this.$store.commit(CACHE_ADMIN_MUTATION_ELIMINAR_ADMIN, this.consorcio_para_asignar_libre.administracion); // Elimino de la cache de administraciones

      this.consorcio_para_asignar_libre = null;
      this.show_sidesheet_asignacion_libres = false;
    },

    /**
     * Metodo para eliminar un acuerdo asignado de la cache de libres y modificar contadores
     */
    eliminarAcuerdoAsignado(acuerdo_libre_asignado){
      this.$store.commit(CACHE_ACUERDOS_LIBRES_MUTATION_ELIMINAR, acuerdo_libre_asignado); // Elimino de la cache de AC Libres el acuerdo asignada
      this.datos_consorcio_pendientes.meta.propuestas_libres--;
      this.datos_consorcio_pendientes.meta.nuevos_consorcios--;
    },

    /**
     * Metodo para responder ante evento de NuevosConsorcios y click en link para asignar acuerdo
     */
    abrirSidesheetAsignacionLibres(consorcio_seleccionado){
      this.consorcio_para_asignar_libre = consorcio_seleccionado;
      this.show_sidesheet_asignacion_libres = true;
    },

    /**
     * Metodo para archivar los consocios seleccionados
     * Ocurre un formateo al modelo y luego se envian al api helper para el envio
     */
    archivarConsorciosPendientes(){

      const url = this.$store.getters[ENDPOINT_GETTER]('editar_archivar');
      if (!url){
        return;
      }

      let formateado  = [];
      this.consorcios_seleccionados.forEach((consorcio) => {
        let modelo_consorcio = new Consorcio();
        modelo_consorcio.id = consorcio.id;
        formateado.push(modelo_consorcio);
      });


      this.$store.commit(LAYOUT_MUTATION_MOSTRAR_LOADING);
      APIAcuerdoComercial.archivarConsorciosPendientes(url, formateado)
        .then(() => {
          // Para evitar el reinicio completo, elimino a mano los consorcios listados
          let consorcios = this.datos_consorcio_pendientes.consorcios;
          this.consorcios_seleccionados.forEach((consorcio) => {
            let index = consorcios.findIndex((c) => c.id === consorcio.id);
            index !== -1 ? consorcios.splice(index, 1) : null;
          });
          this.datos_consorcio_pendientes.consorcios = consorcios;

          // Mensaje de éxito
          const label = this.consorcios_seleccionados.length > 1 ?
            'Se ocultaron ' + this.consorcios_seleccionados.length + ' consorcios' :
            'Se ocultó ' + this.consorcios_seleccionados.length + ' consorcio';
          this.$store.commit(LAYOUT_MUTATION_SNACKBAR_EXITO, label);

          this.consorcios_seleccionados = []; // Limpio los seleccionados ya que se archivaron
        })
        .catch((err) => {
          this.$store.commit(LAYOUT_MUTATION_MODAL_ERROR, {
            titulo: err.title,
            texto: err.detail
          });
        })
        .finally(() => {
          this.$store.commit(LAYOUT_MUTATION_OCULTAR_LOADING);
        });
    },

    /**
     * Emite evento global para actualizar los tabs que listan los acuerdos comerciales, sin tener que hacer GET nuevamente
     * Dependiendo del modo de extender o finalizar el trial, se emite el evento que corresponde
     */
    exitoAccionTrial(acuerdo_actualizado) {
      EventBus.$emit(this.modo_extender_tiempo_aceptacion_modal ?  'acuerdo-comercial:extender-trial' : 'acuerdo-comercial:finalizar-trial', acuerdo_actualizado);
    }
  },
};
</script>

<style lang="scss">
#acuerdo-comercial {

  .v-slide-group__content {
    margin-left: 0;
    margin-right: 0;
    border-radius: 2px;
  }

  .btn--flat {
    background-color: color(naranja);
  }

  .icono-refresh {
    font-size: 24px;
    color: color(gris);

    &--animacion-rotacion {
      animation: rotar360 0.75s ease-in-out;
    }
    &--deshabilitado {
      color: color(gris-claro-secund) !important;
    }
  }

  // Animación de rotación 360
  @keyframes rotar360 {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .boton--carga-agil {
    .v-btn__content {
      flex-direction: row;
      line-height: 24px;
    }

    .boton-icono--carga-agil {
      margin: 0 0 0 5px;
    }
  }

  .boton-oscuro {
    background-color: color(gris-oscuro);
  }

  .boton-asignar-acuerdo{
    background-color: color(naranja);
  }

  // Estilos generales de los chips
  .chip-custom {
    margin-left: 0;
    padding: 8px;
    height: auto !important;
    width: auto !important;

    .v-chip__content {
      display:flex;
      align-items: center;
      padding: 0;
      margin-left: 4px;
      background-color: inherit;
    }

    .ca-chip-label {
      font-size: 14px;
      white-space: break-spaces;
      color: color(dark-secund);
    }

    .ca-chip-izquierda{

      .icon-info {
        color: color(celeste);
      }

      .icon-warning {
        color: color(mango);
      }
    }
  }

  .chip-informativo {
    background-color: color(fondo-claro) !important;
    border: 1px solid color(celeste-claro);
  }

  .chip-warning {
    background-color: color(naranja-claro-secund) !important;
    border: 1px solid color(mango);
  }

  // Estilos generales de los iconos
  .icon-delete, .icon-edit {
    color: color(celeste-claro) !important;
  }

  .icon-info {
    color: color(celeste) !important;
  }

  .icon-warning {
    color: color(mango) !important;
  }

  // Estilo para el mensaje del error
  .ca-bottom-nav .ca-alert {
    padding: 2px;
    margin: auto;
    min-width: 370px;

    .v-alert__wrapper {

      i {
        margin-inline: 8px;
      }

      .v-alert__content {
        font-size: 12px;
        line-height: 14px;
      }
    }
  }


  .v-input--radio-group__input.v-label {
    font-size: 15px;
    color: color(dark);
  }

  // Color deshabilitado
  .v-radio--is-disabled, .v-input--is-disabled{
    .v-label{
      font-size: 15px;
      color: color(gris-deshabilitado) !important;
    }
  }

  // Color mantener estilo cuando en :value se usen booleans
  .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
    font-size: 15px;
    color: color(dark);
  }

  // Estilos copiados de app, para considerar mismo estilo
  .wrapper-loading {
    position: fixed;
    left: 0;
    top: 0;
    background-color: color(blanco);
    opacity: 0.8;
    z-index: 500;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.acuerdo-comercial-modal-error {
  .mensaje{
    font-size: 15px;
    line-height: 20px;
    color: color(dark);
  }
  .mensaje-error-modal{
    color: color(gris);
  }
}

.modal-eliminacion-acuerdo-comercial {

  .modal-content-details {
    font-size: 13px !important;
    line-height: 18px;
  }

  .chip-custom-eliminacion-acuerdo {
    padding: 8px 12px;
    background-color: color(fondo-claro) !important;
    border: 1px solid color(celeste-claro) !important;
    color: color(dark-secund);
    margin: 0;
    height: auto !important;
    border-radius: 18px;

    .v-chip__content {
      background-color: transparent;
      padding: 0;
    }

    .ca-chip-label {
      font-size: 14px;
      line-height: 21px;
      white-space: break-spaces;
      color: color(dark-secund);
    }

    .ca-chip-izquierda {
      padding-right: 6px;
    }

    .icon-info {
      color: color(celeste) !important;
    }
  }

  .v-card__title {
    color: color(dark-secund) !important;
    font-weight: 400 !important;
    line-height: 24px;
  }

  .spacer {
    display:none;
  }

  .v-card__actions.modal-botones {
    display: flex;
    justify-content: space-between;
    background-color: color(naranja);
  }

  .v-card__text.modal-content{
    padding: 22px !important;
    color: color(dark) !important;
    font-size: 15px !important;
    line-height: 20px;
  }

}

.acuerdo-comercial-modal-acuerdo-default {

  .spacer {
    display:none;
  }

  .mensaje {
    font-size: 15px;
    line-height: 20px;
  }

  .v-card__actions.modal-botones {
    display: flex;
    justify-content: space-between;
    background-color: color(naranja);
  }

  .v-card__text.modal-content{
    padding: 22px !important;
  }

  .boton-acuerdo-default-crear-nueva{
    color: color(naranja);
    margin-left: 50px;
  }
}

.acuerdo-comercial-modal-archivar-consorcios{
  max-width: 550px !important;

  .spacer {
    display:none;
  }

  .mensaje {
    font-size: 15px;
    line-height: 20px;
  }

  .v-card__text.modal-content{
    padding: 22px !important;
  }

  .v-card__actions.modal-botones {
    display: flex;
    justify-content: space-between;
    background-color: color(naranja);
  }
}
</style>